
import React from 'react';
import {
  ContextMenu,
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuTrigger,
  ContextMenuSeparator
} from "@/components/ui/context-menu";
import { RotateCw, FlipHorizontal, AlignCenter, Trash2 } from 'lucide-react';

interface DesignContextMenuProps {
  children: React.ReactNode;
  onRotate: () => void;
  onFlip: () => void;
  onCenter: () => void;
  onRemove: () => void;
}

const DesignContextMenu: React.FC<DesignContextMenuProps> = ({
  children,
  onRotate,
  onFlip,
  onCenter,
  onRemove
}) => {
  return (
    <ContextMenu>
      <ContextMenuTrigger asChild>
        {children}
      </ContextMenuTrigger>
      <ContextMenuContent className="w-48 bg-white shadow-md">
        <ContextMenuItem onClick={onRotate} className="cursor-pointer">
          <RotateCw className="h-4 w-4 mr-2" />
          Rotate 15°
        </ContextMenuItem>
        <ContextMenuItem onClick={onFlip} className="cursor-pointer">
          <FlipHorizontal className="h-4 w-4 mr-2" />
          Flip Horizontally
        </ContextMenuItem>
        <ContextMenuItem onClick={onCenter} className="cursor-pointer">
          <AlignCenter className="h-4 w-4 mr-2" />
          Center Design
        </ContextMenuItem>
        <ContextMenuSeparator />
        <ContextMenuItem onClick={onRemove} className="cursor-pointer text-red-500">
          <Trash2 className="h-4 w-4 mr-2" />
          Remove Design
        </ContextMenuItem>
      </ContextMenuContent>
    </ContextMenu>
  );
};

export default DesignContextMenu;
